module.exports = __webpack_public_path__ + "static/print-token-proxies-17930f9bc1e5a742ef29a3e4a736b9d5.jpg";